import React, { useEffect } from 'react';

import { requestFlow } from 'src/dataLayer/remoteData/babbelS3';
import { FlowConfig } from 'src/viewLayer/components/Flow/types';

interface UseFetchFlowParams {
  setFlowConfig: React.Dispatch<React.SetStateAction<FlowConfig>>;
  flowConfig: FlowConfig | null;
  flowId: string;
}

export default ({
  flowConfig,
  flowId,
  setFlowConfig
}: UseFetchFlowParams): void => {
  useEffect(() => {
    // if the downloaded flowConfig's ID is equal to the one in the url no need to download it again
    if (flowConfig && flowConfig.id === flowId) return;

    const getFlow = async (): Promise<void> => {
      await requestFlow(flowId, setFlowConfig);
    };
    // we don't need to await this Promise, since it will set some state and cause the app to re-render anyways
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getFlow();
  }, [flowConfig, flowId, setFlowConfig]);
};
